module.exports = __webpack_public_path__ + "static/media/everenviro.ec35c223.svg";